import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type PortalView = "admin" | "user";

export interface UIState {
  helpPanelOpen: boolean;
  portalView: PortalView;
}

const initialState: UIState = {
  helpPanelOpen: false,
  portalView: "admin",
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openHelpPanel: (state) => {
      state.helpPanelOpen = true;
    },
    closeHelpPanel: (state) => {
      state.helpPanelOpen = false;
    },
    toggleHelpPanel: (state) => {
      state.helpPanelOpen = !state.helpPanelOpen;
    },
    setPortalView: (state, action: PayloadAction<PortalView>) => {
      state.portalView = action.payload;
    },
  },
});

const { openHelpPanel, closeHelpPanel, toggleHelpPanel } = uiSlice.actions;
export const { setPortalView } = uiSlice.actions;
export default uiSlice.reducer;
